import { graphql } from "gatsby"
import React from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import Posts from "../components/Posts"

const CategoryTemplate = ({ data }) => {
  const {
    categories: { nodes: categoryPosts },
  } = data

  const url = typeof window !== "undefined" ? window.location.href : ""
  const trunc = url.substring(23) //23 later!

  return (
    <Layout>
      <Seo Sitetitle={trunc} />
      <Posts categoryPosts={categoryPosts} />
    </Layout>
  )
}

export const query = graphql`
  query GetCategories($category: String) {
    categories: allStrapiBlogs(
      filter: { category: { eq: $category } }
      sort: { fields: date, order: DESC }
    ) {
      nodes {
        id
        slug
        title
        category
        shortDescription
        content
        isPopular
        Image {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED)
            }
          }
        }
      }
    }
  }
`

export default CategoryTemplate
